import React from 'react';
import { Alert } from 'antd';
import './ErrorBoundary.css';

interface ErrorBoundaryProps {
    children: React.ReactNode;
    sectionName?: string;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error(`ErrorBoundary [${this.props.sectionName ?? 'App'}] caught error:`, error, errorInfo);
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            const section = this.props.sectionName ?? 'Application';
            return (
                <div className="spona-error-boundary">
                    <Alert
                        message={`Greška u sekciji: ${section}`}
                        description={`Nešto je pošlo naopako. Osvežite stranicu ili kontaktirajte podršku. (${this.state.error?.message ?? 'Nepoznata greška'})`}
                        type="error"
                        showIcon
                    />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
